import { Link } from "react-router-dom";
import { PRODUCTS, MEDIA_IP, STRUCTURAL, ACTIVE_INITIATIVES } from "../data/content";
import { Reveal } from "./Reveal";

// Institutional portfolio index — lane rows with maturity labels, built on the
// THG line geometry. Stacks cleanly on mobile. Not an org chart, not a logo wall.
export const PortfolioMap = () => {
    const lanes = [
        {
            name: "WarRoom Solutions",
            to: "/warroom",
            items: PRODUCTS.filter((p) => p.division === "WarRoom Solutions").map((p) => ({
                name: p.name,
                status: p.status,
                to: `/portfolio/${p.slug}`,
            })),
        },
        {
            name: "WarRoom Labs",
            to: "/warroom",
            items: [
                { name: "Bud's Market Intelligence Desk", status: "Live", to: "/portfolio/bud" },
                { name: "Published Research", status: "Active", href: "https://warroomlabs.substack.com/" },
            ],
        },
        {
            name: "THG Retail",
            to: "/portfolio/retail",
            note: "Site Under Reconstruction",
            items: [{ name: "PBLC" }, { name: "Hat Bar" }, { name: "Headwear" }, { name: "Apparel" }],
        },
        {
            name: "Government / Research",
            to: "/government-research",
            items: [
                { name: "THGov", status: "Active Capability" },
                { name: "THLS AI", status: "Active Development" },
            ],
        },
        {
            name: "Sports / Media / IP",
            to: "/portfolio/media",
            items: MEDIA_IP.map((e) => ({ name: e.name, status: e.status, to: e.to })),
        },
        {
            name: "Digital Businesses",
            items: [{ name: "HotelsTrips.com", status: "Operating Digital Business", to: "/portfolio/hoteltrips" }],
        },
        {
            name: "Corporate Initiatives",
            items: ACTIVE_INITIATIVES.filter((a) => a.name === "C.A.R.T.-Right Fund").map((a) => ({
                name: a.name,
                status: a.status,
            })),
        },
        {
            name: "Investment / Structural",
            items: STRUCTURAL.map((s) => ({ name: s.name, status: s.status })),
        },
    ];

    const ItemName = ({ item }) =>
        item.to ? (
            <Link to={item.to} className="text-thg-secondary hover:text-white transition-colors duration-300">
                {item.name}
            </Link>
        ) : item.href ? (
            <a href={item.href} target="_blank" rel="noopener noreferrer" className="text-thg-secondary hover:text-white transition-colors duration-300">
                {item.name}
            </a>
        ) : (
            <span className="text-thg-secondary">{item.name}</span>
        );

    return (
        <div className="border border-thg-border" data-testid="portfolio-map">
            <div className="flex items-center gap-4 p-6 md:p-8 border-b border-thg-border bg-thg-surface border-l-2 border-l-thg-red">
                <img src="/assets/thg-shield-sm.png" alt="" className="h-8 w-auto" />
                <span className="font-display text-lg md:text-xl font-medium text-white tracking-wide">
                    Titan Haven Group LLC
                </span>
            </div>
            {lanes.map((lane, i) => (
                <Reveal
                    key={lane.name}
                    delay={i * 0.04}
                    className="grid grid-cols-1 md:grid-cols-12 gap-2 md:gap-6 px-6 md:px-8 py-5 md:py-6 border-b border-thg-border last:border-b-0 hover:bg-thg-surface/50 transition-colors duration-300"
                >
                    <div className="md:col-span-4 flex items-baseline gap-3">
                        <span className="text-xs text-thg-red font-bold shrink-0">{String(i + 1).padStart(2, "0")}</span>
                        <div>
                            {lane.to ? (
                                <Link
                                    to={lane.to}
                                    className="font-display text-lg md:text-xl font-medium text-white hover:text-thg-secondary transition-colors duration-300"
                                >
                                    {lane.name}
                                </Link>
                            ) : (
                                <span className="font-display text-lg md:text-xl font-medium text-white">{lane.name}</span>
                            )}
                            {lane.note && (
                                <span className="block mt-1 text-[10px] tracking-[0.18em] uppercase text-thg-tertiary">{lane.note}</span>
                            )}
                        </div>
                    </div>
                    <div className="md:col-span-8 flex flex-wrap gap-x-6 gap-y-2 items-baseline md:pl-0 pl-7">
                        {lane.items.map((item) => (
                            <span key={item.name} className="text-sm">
                                <ItemName item={item} />
                                {item.status && (
                                    <span className="ml-2 text-[10px] tracking-[0.15em] uppercase text-thg-tertiary">{item.status}</span>
                                )}
                            </span>
                        ))}
                    </div>
                </Reveal>
            ))}
        </div>
    );
};
